<span [id]="name" [ngClass]="cssClass">
  <div class="flex flex-row items-center justify-start gap-1 p-1">
    <span *ngIf="iconName" class="material-symbols-rounded icon-16" >{{
      iconName
    }}</span>
    <span class="text-button-md min-w-8"  [id]="id">
      <ng-content></ng-content>
    </span>
  </div>
</span>
